

































































































































































import Vue from 'vue'
import AOS from 'aos'
import Lightbox from '../components/Lightbox.vue'
// @ts-ignore
import Cases from '../db.ts'


export default Vue.extend({
    name: 'Case',
    components: { Lightbox },
    data(){
        return { content: Cases(1).content }
    },
    beforeMount(){
        window.addEventListener('resize', this.prepareForeword)
    },
    mounted(){
        this.prepareForeword()
    },
    methods: {
        prepareForeword(){
            try {
                let case_foreword = this.$refs.case_foreword as HTMLElement,
                    balloon_r = this.$refs.balloon_right as HTMLElement,
                    balloon_l = this.$refs.balloon_left as HTMLElement
                let wrapperHeight = case_foreword.offsetHeight,
                    balloon_lHeight = balloon_l.offsetHeight,
                    balloon_rHeight = balloon_r.offsetHeight

                case_foreword.style.marginBottom = 0 - wrapperHeight + 60 + 'px'
                balloon_l.dataset.aosOffset = `${balloon_lHeight + 100}`
                balloon_r.dataset.aosOffset = `${balloon_rHeight + 100}`
                console.info('Foreword animations prepared')
            } catch(e) {
                console.log('Foreword animations not prepared', e)
            }
        }
    }
})

